import { useEffect, useState } from "react";
import { Flag, X } from "lucide-react";
import { cycleFlag, flagColor, getLabels, flagHex, removeFlag } from "../lib/flags";
import { useAuth } from "../contexts/AuthContext";

// Tap to cycle the colours you already have. Premium members get a brand new
// colour at the end of each round (up to 50); free members cycle through 4.
export const FlagButton = ({ flagKey, tune, version = 1, edited = false, abc = "" }) => {
  const { user } = useAuth();
  const premium = !!(user?.unlimited_searches || user?.is_admin);
  const [color, setColor] = useState(null);
  const [labels, setLabels] = useState(getLabels());

  useEffect(() => {
    const update = () => {
      setColor(flagColor(flagKey));
      setLabels(getLabels());
    };
    update();
    window.addEventListener("flag-changed", update);
    return () => window.removeEventListener("flag-changed", update);
  }, [flagKey]);

  const onClick = () => {
    setColor(
      cycleFlag(
        {
          key: flagKey,
          tune_id: tune.tune_id,
          name: tune.name,
          type: tune.type,
          version,
          edited,
          abc,
        },
        { premium }
      )
    );
  };

  const hex = flagHex(color);

  return (
    <span className="flex items-center gap-1">
      <button
        onClick={onClick}
        className="flex items-center gap-1.5 rounded-full border px-4 py-2 text-sm font-bold transition-colors"
        style={{
          borderColor: hex || "#e5e0d8",
          backgroundColor: hex ? `${hex}14` : "#fff",
          color: hex || "#2d2824",
        }}
        data-testid="flag-button"
        data-flag-color={color || "none"}
        title={
          color
            ? `${labels[color] || color} · tap for the next colour`
            : "Flag this tune (tap to cycle colours)"
        }
      >
        <Flag className="h-4 w-4" style={{ fill: hex || "none" }} />
        {color ? labels[color] || color : "Flag"}
      </button>
      {color && (
        <button
          onClick={() => {
            removeFlag(flagKey);
            setColor(null);
          }}
          className="rounded-full border border-[#e5e0d8] bg-white p-1.5 text-[#a89e92] hover:text-[#2d2824]"
          data-testid="flag-clear"
          aria-label="remove flag"
          title="Remove the flag"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </span>
  );
};
